import Section from '@components/atoms/Section';
import { Heading2 } from '@components/atoms/Typography';
import BreadCrumbs from '@components/molecules/BreadCrumbs';
import GridLinkList from '@components/molecules/list/GridLinkList';
import PageContainer from '@components/molecules/PageContainer';
import DefaultHeader from '@components/organisms/headers/DefaultHeader';
import ROUTES from '@lib/constants/routes';
import { FipeVehicleTypeUrl } from '@lib/constants/routes/fipeRoutes';
import { fipeDictionary } from '@lib/helpers/texts';
import { fipeBreadCrumbs } from '@lib/helpers/ui/breadcrumbs';
import prisma from '@lib/services/prisma';
import { GetStaticPaths, GetStaticProps } from 'next';
import React from 'react';

interface Props {
  type: FipeVehicleTypeUrl;
  brands: string[];
}

const Page = ({ brands, type }: Props) => {
  if(!type) return <PageContainer loading />

  return (
    <PageContainer
      title={`Tabela FIPE ${fipeDictionary[type].plural}`}
      metaDescription={`Confira os valores da tabela FIPE para as marcas de ${fipeDictionary[type].plural}`}
    >
      <DefaultHeader
        title={`Tabela FIPE ${fipeDictionary[type].plural}`}
        subtitle={`Veja os valores atualizados de todos as marcas de ${fipeDictionary[type].plural} na tabela FIPE`} />
      <Section>
        <Heading2 center>
          Selecione a marca de {fipeDictionary[type].singular}
        </Heading2>
        <GridLinkList
          prefetch={false}
          textAlign="center"
          links={brands.map((brand) => ({
            label: `Tabela Fipe ${brand}`,
            path: ROUTES.fipe.brand({ type, brand }),
          }))} />
      </Section>
      <Section style={{ paddingTop: 0 }}>
        <BreadCrumbs links={fipeBreadCrumbs({ type })} />
      </Section>
    </PageContainer>
  );
};

export const getStaticProps: GetStaticProps<Props> = async ({ params }) => {
  const { type } = params as Record<string, string>;

  const brands = await prisma.fipeModel.findMany({
    distinct: ['brand'],
    where: {
      vehicleType: fipeDictionary[type as FipeVehicleTypeUrl].fipeType,
    },
    select: {
      brand: true,
    },
    orderBy: {
      brand: 'asc',
    },
  });

  if (!brands.length) return { notFound: true };

  return {
    props: {
      type: type as FipeVehicleTypeUrl,
      brands: brands.map(({ brand }) => brand),
    },
  };
};

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: ['/fipe/motos'],
  fallback: true,
});

export default Page;
